import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@env/environment";
import { Observable } from "rxjs";

import { CheckResetPasswordOtpResponse } from "@core/models/api.response";
import {
  RequestResetPasswordCheckOTPDTO,
  RequestResetPasswordNewPasswordDTO,
} from "@core/models/forgot-password.interface";

@Injectable({
  providedIn: "root",
})
export class PasswordResetService {
  constructor(private http: HttpClient) {}

  requestOTP(email: string) {
    return this.http.post<CheckResetPasswordOtpResponse>(
      `${environment.apiUri}/verify/request-reset-otp`,
      {
        email: email,
      },
    );
  }

  checkOTP(
    data: RequestResetPasswordCheckOTPDTO,
  ): Observable<CheckResetPasswordOtpResponse> {
    return this.http.post<CheckResetPasswordOtpResponse>(
      `${environment.apiUri}/verify/check-reset-otp`,
      {
        email: data.email,
        otp: data.otp,
      },
    );
  }

  resetPassword(data: RequestResetPasswordNewPasswordDTO): Observable<void> {
    return this.http.post<void>(`${environment.apiUri}/auth/reset-password`, {
      email: data.email,
      newPassword: data.newPassword,
      otp: data.otp,
    });
  }
}
